import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  isInRole:boolean;

  constructor(private auth:AuthService) { }

  ngOnInit(): void {
    this.isInRole = this.auth.isInRole(['Admin','Moderator']);
  }

}
